import { useRef, type ReactNode } from 'react';
import { StoreApi } from 'zustand';
import {
    createParamsStore,
    IParamsStore,
    ParamsStoreContext,
} from '@shadcn-features/core/ShadcnTabulator/stores/params';
import { ShadcnTabulatorParamsType } from '@shadcn-features/core/ShadcnTabulator/types';

type Props = {
    initialParams?: ShadcnTabulatorParamsType;
    onParamsChange?: (params: ShadcnTabulatorParamsType) => void;
    children: ReactNode;
};

export function TableFieldParamsProvider({
    initialParams = {},
    onParamsChange,
    children,
}: Props) {
    const storeRef = useRef<StoreApi<IParamsStore>>();
    const onParamsChangeRef = useRef(onParamsChange);

    onParamsChangeRef.current = onParamsChange;

    if (!storeRef.current) {
        storeRef.current = createParamsStore(
            { page: 1, size: 10, ...initialParams },
            undefined,
            (params) => onParamsChangeRef.current?.(params),
        );
    }

    return (
        <ParamsStoreContext.Provider value={storeRef.current}>
            {children}
        </ParamsStoreContext.Provider>
    );
}
